import { useEffect, useState } from 'react';

const toHex = buffer => Array.from(new Uint8Array(buffer), byte => byte.toString(16).padStart(2, '0')).join('');

// SHA-256 of a section heading; the visible node shows the first eight hex digits.
export const useDigest = text => {
  const [digest, setDigest] = useState('');
  useEffect(() => {
    let live = true;
    crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(buffer => { if (live) setDigest(toHex(buffer)); });
    return () => { live = false; };
  }, [text]);
  return digest;
};
